// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J_WM","toggle":"styles_toggle__rOkyC","preview":"styles_preview__38UYk"};